import classes from "./Navbar.module.css";
import {ActionIcon, Button, Text, Tooltip} from "@mantine/core";

interface NavbarItemProps {
    icon: React.ReactNode;
    label: string;
    onClick?: () => void;
    expanded: boolean;
}

export const NavbarItem: React.FC<NavbarItemProps> = ({
    icon,
    label,
    onClick,
    expanded,
}) => {
    if (expanded) {
        return (
            <Button
                variant="subtle"
                size="xs"
                px="xs"
                leftSection={icon}
                onClick={onClick}
                c="white"
                fullWidth
                justify="flex-start"
                className={classes.navbarItem}
            >
                <Text size="sm" color={"white"}>
                    {label}
                </Text>
            </Button>
        );
    }

    return (
        <Tooltip label={label} position="right">
            <ActionIcon
                variant="subtle"
                color="white"
                size="lg"
                onClick={onClick}
                className={classes.navbarItemCollapsed}
                aria-label={label}
            >
                {icon}
            </ActionIcon>
        </Tooltip>
    );
};
